import { createFileRoute } from '@tanstack/react-router'
import { guardNoAccess } from '@pa/staff'
import { z } from 'zod'
import { NoAccess } from '@/features/home'

const search = z.object({ reason: z.enum(['impersonation-ended']).optional().catch(undefined) })

/**
 * No access (Frontend §5.2): no active membership (super admins included, D-40). `reason=impersonation-ended`: the
 * impersonation ended before its clinic opened (Frontend §6.4 step 3).
 */
export const Route = createFileRoute('/no-access')({
  validateSearch: search,
  beforeLoad: ({ context }) => guardNoAccess(context, 'clinic'),
  component: function NoAccessRoute() {
    const { me, env } = Route.useRouteContext()
    const { reason } = Route.useSearch()
    return (
      <NoAccess me={me} adminOrigin={env.VITE_ADMIN_APP_ORIGIN} impersonationEnded={reason === 'impersonation-ended'} />
    )
  },
})
